import clientAxios from "../config";

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

/**
 * Listado paginado de notificaciones del usuario autenticado.
 * params: { unread, per_page, page }
 *  - unread=1 → solo no leídas
 */
const getNotifications = (token, params = {}) =>
    clientAxios.get(`/api/notifications`, { params, ...auth(token) });

/**
 * Conteo de no leídas — endpoint barato pensado para el polling del
 * badge de la campana. Devuelve `{ unread_count }`.
 */
const getUnreadCount = (token) =>
    clientAxios.get(`/api/notifications/unread-count`, auth(token));

/**
 * Marca una notificación como leída. Idempotente.
 */
const markNotificationRead = (token, id) =>
    clientAxios.post(`/api/notifications/${id}/read`, {}, auth(token));

/**
 * Marca todas las no leídas como leídas.
 */
const markAllNotificationsRead = (token) =>
    clientAxios.post(`/api/notifications/read-all`, {}, auth(token));

export {
    getNotifications,
    getUnreadCount,
    markNotificationRead,
    markAllNotificationsRead,
};
